import { Component, OnInit } from "@angular/core";
import { jwtDecode } from "jwt-decode";
import { Router } from "@angular/router";
import { DataService } from "@app/services/data.service";
import { FilterService } from "@app/services/filter.service";
import {StatusTranslatorService} from "@app/services/status.translator.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
              private dataService: DataService,
              private statusTranslatorService: StatusTranslatorService,
              public filterService: FilterService) {}

  organizationCode = "";
  userRoles = "";
  showTable = true;
  showRegistry = true;
  navItems = [

    // {
    //   link: "/sign-demo",
    //   title: "КЕП Демо",
    // },
    {
      link: "/reserves",
      title: "Запаси",
      order: "0",
    },
    {
      link: "/supplies",
      title: "Поставки",
      order: "1",
    },
    {
      link: "/organizations",
      title: "Організації",
      order: "2",
    },
    {
      link: "/recipients",
      title: "Отримувачі",
      order: "3",
    },
    {
      link: "/actions",
      title: "Журнал дій",
      order: "5",
    },
    {
      link: "/postponed",
      title: "Відтерміноване",
      order: "6",
    },
  ];

  ngOnInit(): void {

    this.organizationCode = (
      jwtDecode(localStorage["access_token"]) as any
    ).organizationInfo.code;
    this.userRoles = (
      jwtDecode(localStorage["access_token"]) as any
    ).realm_access.roles.join(" ");
    this.onShowMyOrganization({ state: true });
  }

  onShowMyOrganization({ state }: { state: boolean; }): void {
    console.log("User roles: " + this.userRoles);
    this.dataService.organizationCode = state ? this.organizationCode : "";

    if (this.userRoles.indexOf("doz-member-role") > -1) {
      this.dataService.userRole = "DOZ";
      this.navItems = [];
      this.navItems.push({
        link: "/supplies",
        title: "Поставки",
        order: "1",
      });
      this.navItems.push({
        link: "/recipients",
        title: "Отримувачі",
        order: "3",
      });
      this.navItems.push({
        link: "/distributions/doz",
        title: "Розподіли",
        order: "4",
      });
      this.navItems.push({
        link: "/actions",
        title: "Журнал дій",
        order: "5",
      });
      this.sortNavItems();
      return;
    }

    if (this.userRoles.indexOf("logistics-manager") > -1) {
      this.dataService.userRole = "DOZ";
      this.navItems.forEach((item, index) => {
        if (item.link === "/organizations") {
          this.navItems.splice(index, 1);
        }
      });
      this.navItems.push({
        link: "/distributions/doz",
        title: "Розподіли",
        order: "4",
      });
      this.sortNavItems();
      return;
    }
    if (this.userRoles.indexOf("logistics-mpu-manager") > -1 || this.userRoles.indexOf("logistics-mpu-sub-manager") > -1) {
      this.dataService.userRole = "MZU";
      console.log("User type:", this.dataService.userRoleValue.getValue());

      this.navItems.push({
        link: "/distributions/mzu",
        title: "Розподіли",
        order: "4",
      });
      this.sortNavItems();
      return;
    }

    if (this.userRoles.indexOf("logistics-expert") > -1) {
      this.dataService.userRole = "ZOZ";
      this.sortNavItems();
      return;
    }

    this.sortNavItems();
    this.dataService.userRole = "UNKNOWN";
  }

  sortNavItems(): void {
    this.navItems.sort((o1, o2) => o1.order.localeCompare(o2.order));
  }

  showFilterButtons(): boolean {
    if (this.filterService.goodSpecificationsShowed) {
      return false;
    }
    return [
      "/supplies",
      "/reserves",
      "/actions",
      "/distributions/mzu",
      "/distributions/doz",
      "/basket",
      "/organizations",
      "/recipients",
    ].includes(this.currentPath());
  }

  currentPath(): string {
    return this.router.routerState.snapshot.url;
  }

  isPage(path: string): boolean {
    return [`/${path}`].includes(this.router.routerState.snapshot.url);
  }

  showFilter(): void {
    if ("/supplies" === this.currentPath()) {
      this.filterService.showSuppliesFilter = true;
    } else if ("/reserves" === this.currentPath()) {
      this.filterService.showReservesFilter = true;
    } else if ("/actions" === this.currentPath()) {
      this.filterService.showActionsFilter = true;
    } else if ("/distributions/mzu" === this.currentPath()) {
      this.filterService.distributionsMZUFilter = true;
    } else if ("/distributions/doz" === this.currentPath()) {
      this.filterService.distributionsDOZFilter = true;
    } else if ("/basket" === this.currentPath()) {
      this.filterService.basketFilter = true;
    } else if ("/organizations" === this.currentPath()) {
      this.filterService.organizationsFilter = true;
    } else if ("/recipients" === this.currentPath()) {
      this.filterService.recipientsFilter = true;
    }
    //this.filterService.loadDistinctsForDropdowns();
  }

  trackByIndex(index: number): number {
    return index;
  }

  deleteSuppliesFilterItem(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.suppliesStateChanged();
    }
  }

  deleteReservesFilterItem(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.reservesStateChanged();
    }
  }

  deleteFilterItem(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.suppliesStateChanged();
    }
  }

  deleteFilterItemActions(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.actionsStateChanged();
    }
  }

  deleteFilterItemDistributionsMZU(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.distributionsMZUStateChange();
    }
  }

  deleteFilterItemDistributionsDOZ(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.distributionsDOZStateChange();
    }
  }

  deleteFilterItemRecipientsDOZ(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1)
      this.filterService.recipientsDOZStateChange()
    }
  }

  deleteFilterItemRecipientsMZU(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1)
      this.filterService.recipientsMZUStateChange()
    }
  }

  deleteFilterItemOrganizationsItem(aray: any[], item: any) {
    const index = aray.indexOf(item, 0);
    if (index > -1) {
      aray.splice(index, 1);
      this.filterService.organizationsMZUStateChange();
    }
  }

  resetFilter() {
    this.filterService.resetFilter(this.currentPath());
  }

  deleteFilterItemDate(dateType: string) {
    if ("actualDate" === dateType) {
      this.filterService.supplies.actualDate = null;
      this.filterService.suppliesStateChanged();
    } else if ("expectedDate" === dateType) {
      this.filterService.supplies.expectedDate = null;
      this.filterService.suppliesStateChanged();
    } else if ("controlDate" === dateType) {
      this.filterService.reserves.controlDate = null;
      this.filterService.reservesStateChanged();
    } else if ("createdAt" === dateType) {
      this.filterService.distributionsMZU.createdAt = null;
      this.filterService.distributionsMZUStateChange();
      this.filterService.distributionsDOZ.createdAt = [];
      this.filterService.distributionsDOZStateChange();
    }
  }

  getDirectionLabel(id: string): string {
    const match = this.filterService.directionOptions.find(dir => dir.value === id);
    return match ? match.label : id.toString(); // fallback to id if label not found
  }

  translateStatus(status: string) {
    return this.statusTranslatorService.translateStatus(status);
  }
}
